// Terrain colours, authored as the sRGB colour each should have ON SCREEN on flat lit ground
// (material.ts converts them to albedo with tsl/color.ts `screen()`). Each biome has a base and an
// alternate tone mixed by large-scale noise, so plains are never one flat colour, plus detail tones
// for tufts, bushes, stones, canopy, wetlands and rock. Tuned toward the Civ VI look: rich but
// natural greens that keep some blue, warm ochre plains, pale warm sand, cool snow.

export const BIOME_COLORS = {
  grass: ['#4e812f', '#79a345'],
  plains: ['#a19a55', '#c2b46c'],
  desert: ['#e6cd98', '#d8b882'],
  tundra: ['#7e8262', '#a69d7d'],
  snow: ['#e8eef6', '#cfdbea'],
  forest: ['#436f30', '#63903f'],
  jungle: ['#326e32', '#58963f'],
  seabed: ['#d9c99d', '#c1ad80'],
} as const;

export const SURFACE_COLORS = {
  grassDark: '#41692b',
  grassSun: '#8bb04f',
  dryGrass: '#9fa455',
  plainsDry: '#c6b67c',
  bush: '#5f6e35',
  dune: '#d4ab72',
  duneShade: '#c0925e',
  gravel: '#ae9676',
  stone: '#9c988e',
  lichen: '#9c9b64',
  heather: '#8e6f64',
  forestGap: '#243f1d',
  jungleGap: '#173a19',
  rock: '#918b82',
  rockDark: '#5e5a56',
  rockLight: '#bcb5aa',
  rockWarm: '#94826d',
  cliff: '#88745e',
  // Below the tone map's highlight shoulder, so caps keep their lit and shaded sides.
  snowCap: '#dde5ef',
  snowShade: '#a9bbd5',
  seabedDeep: '#2d5b63',
  beach: '#eadcab',
  floodGreen: '#6f9c3c',
  floodLush: '#8cb04c',
  floodSilt: '#6f6445',
  marshMud: '#5f5c3e',
  marshReed: '#6f7a3f',
  marshWater: '#3f5f63',
  marshSky: '#7f9fae',
} as const;
